<template>
   <div class="voucher">
      <div class="top-content clearfix">
         <img src="/img/logo.png" alt="" class="logo">
         <div class="right-content clearfix r">
            <div class="content-box clearfix">
               <div class="h5 r">RUBiS KENYA</div>
            </div>
            <div class="help r help-large">E: vouchers@rubiskenya.com | Help Line: +254789898086</div>
         </div>
      </div>

      <div class="form-container" v-show="!is_valid">
         <div class="row justify-content-md-center">
            <div class="col-md-6 col-lg-5 col-xl-4">
               <Form 
                  class_binding="row form-box" 
                  :ref="Model.forms.voucher_code.name" 
                  :forms="Model.forms.voucher_code.forms" 
                  :form_data="Model.forms.voucher_code.data"
                  @button-click="validateVoucher({ref: $refs[Model.forms.voucher_code.name], id: $route.params.voucher_code})"
               />
            </div>
         </div>
      </div>

      <div class="row justify-content-md-center">
         <div class="col-lg-11 col-xl-8">
            <div class="voucher-container" >
               <div class="btn-box clearfix">
                  <div class="btn btn-primary r" @click="downloadVoucher({id: $route.params.voucher_code})"><i class="fa fa-download"></i> Download Voucher</div>
               </div>
               <div class="voucher-card">
                  <div class="row">
                     <div class="col-md-8">
                        <div class="image-back">
                           <div class="overlay">
                              <div class="row">
                                 <div class="col-md-7 col-xl-8">
                                    <div class="code-box">
                                       <div class="names" v-if="voucher && voucher.names">{{voucher.names}}</div>
                                       <div class="names" v-else>XXXX XXXXXXX</div>
                                       <div class="code" v-if="voucher && voucher.code">{{voucher.code}}</div>
                                       <div class="names" v-else>XXXX-XXXX-XXXX-XXXX</div>
                                       <div class="v-container">
                                          <div class="voucher-box">
                                             <div class="red-code left"></div>
                                             <div class="red-code right"></div>
                                             <div class="sec">GIFT VOUCHER</div>
                                          </div>
                                       </div>
                                       <div class="web">www.rubiskenya.com</div>
                                    </div>
                                 </div>
                                 <div class="col-md-5 col-xl-4 image-box">
                                    <!-- <img src="/img/gift.png" alt="Gift Image" class="gift"> -->
                                    <canvas id="qr-canvas" class="gift"></canvas>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="col-md-4">
                        <div class="text-back">
                           <div class="small-circle top"></div>
                           <div class="small-circle bottom"></div>
                           <div class="semi-circle"></div>
                           <div class="amount-box">
                              <div class="title">GIFT VOUCHER</div>
                              <div class="amount" v-if="voucher && voucher.amount">KES {{utils.numberWithCommas(voucher.amount)}}</div>
                              <div class="amount" v-else>KES 0</div>
                              <div class="details-box">
                                 <div class="valid" v-if="voucher && voucher.amount">Valid Until: {{dayjs(voucher.expires_at).format('DD MMM YYYY')}}</div>
                                 <div class="valid" v-else>Valid Until: XX XXX XXXX</div>
                                 <div class="txt">Vouchers can only be redeemed once.</div>
                              </div>
                           </div>
                           <div class="image-box">
                              <img src="/img/logo.png" alt="Logo" class="logo">
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      
      <div class="foot">
         <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10 col-xl-9">
               <div class="row">
                  <div class="col-lg-5">
                     <div class="txt">&copy; {{new Date().getFullYear()}} <b>Purplefire LTD.</b> All Rights Reserved</div>
                  </div>
                  <div class="col-lg-7">
                     <div class="links r">
                        <a href="#" class="link">Terms &amp; Condition</a>
                        <a href="#" class="link">RUBiS Kenya</a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import voucher from "./download-voucher.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('voucher')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('voucher',voucher,this.$store)
   },
   components:{
      Form: () => import("clarks/components/form"),
      TableForm: () => import("clarks/components/form-input-table"),
   },
   data (){
      return {
         dayjs,
         utils
      };
   },
   computed: {
      ...mapGetters([
         'Model',
         'voucher',
         'is_valid',
         'current',
         'loading',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'validateVoucher',
         'downloadVoucher',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('voucher',voucher,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
$background-color: #f7f8fc;
$voucher-grey: #BFBFBF;

   .voucher{
      background: $background-color;
      min-height: 100vh;
      
      .form-container{
         position: fixed;
         top: 0;
         bottom: 0;
         left: 0;
         right: 0;
         z-index: 100;
         background: rgba($white, .93);
         padding: calc(25% - 190px) 0 0 0;

         .form-box{
            background: $white;
            border-radius: $input-border-radius;
            border: solid 1px $border-grey;
         }
      }
      .voucher-container{
         padding: 50px 0;

         .btn-box{
            margin: 30px 0 40px 0;
         }
      }

      .voucher-card{
         .col-md-8,.col-md-4{
            padding: 0 !important;
         }
         .image-back{
            background: url('/img/fuel-bg-min.jpg') no-repeat;
            background-size: cover;
            background-position: 50% 50%;
            width: 100%;
            height: 100%;
            min-height: 200px;
            position: relative;
            
            .overlay{
               background: rgba( $primary, .6 );
               position: absolute;
               top: 0;
               bottom: 0;
               left: 0;
               right: 0;

               .code-box{
                  margin: 50px 0 30px 0;
               }
               .names{
                  font-size: 20px;
                  text-transform: uppercase;
                  font-family: $font-black;
                  color: $white;
               }
               .code{
                  font-size: 30px;
                  font-family: $font-black;
                  color: $white;
               }
               .web,.voucher-box,.code,.names{
                  text-align: center;
                  color: $white;
               }
               .v-container{
                  display: flex;
                  justify-content: center;

                  .voucher-box{
                     width: 230px;
                     background: $secondary;
                     padding: 0 15px;
                     position: relative;

                     .red-code{
                        position: absolute;
                        top: calc(50% - 5px);
                        width: 5px;
                        height: 10px;
                        background: $secondary;

                        &.right{
                           right: -5px;
                           border-radius:  0 5px 5px 0;
                        }
                        &.left{
                           border-radius: 5px 0 0 5px;
                           left: -5px;
                        }
                     }
                     .sec{
                        border-left: dashed 2px $primary;
                        border-right: dashed 2px $primary;
                        padding: 5px 0;
                        font-weight: bold;
                        font-size: 14px;
                     }
                  }
               }
               .web{
                  font-family: $font-bold;
                  margin: 20px 0 0 0;
               }
               .image-box{
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  .gift{
                     margin-top: 20px;
                     width: auto;
                     max-width: 80%;
                     max-height: 70%;
                     height: auto;
                  }
               }
            }
         }

         .text-back{
            background: $white;
            width: 100%;
            height: 100%;
            border-left: dashed 3px $voucher-grey;
            position: relative;
            padding: 20px 40px;
            padding-bottom: 40%;


            .amount-box{
               border: solid 2px $secondary;
               position: relative;
               padding: 20px 10px 10px 10px;

               .title{
                  position: absolute;
                  top: -10px;
                  left: 20px;
                  right: 20px;
                  background: $white;
                  text-align: center;
                  font-family: $font-bold;
               }
               .amount{
                  color: $primary;
                  font-size: 30px;
                  margin: -10px 0 5px 0;
                  // line-height: 45px;
                  font-family: $font-black;
                  text-align: center;
               }
            }
            .details-box{
               border-top: dashed 2px $secondary;
               margin: 0 -10px;
               padding: 5px 10px 0 10px;
               text-align: center;

               .valid{
                  font-size: 15px;
                  // font-family: $font-bold;
                  font-weight: bold;
               }
               .txt{
                  font-size: 12px;
               }
            }
            .semi-circle{
               position: absolute;
               top: calc(50% - 20px);
               width: 20px;
               height: 40px;
               border-radius: 20px 0 0 20px;
               right: 0;
               background: $voucher-grey;
            }
            .small-circle{
               position: absolute;
               width: 20px;
               height: 10px;
               left: -12px;
               background: $voucher-grey;


               &.top{
                  border-radius: 0 0 10px 10px;
                  top: 0;
               }
               &.bottom{
                  border-radius: 10px 10px 0 0;
                  bottom: 0;
               }
            }

            .image-box{
               text-align: center;
               position: absolute;
               bottom: 10px;
               left: 0;
               right: 0;

               .logo{
                  width: auto;
                  height: auto;
                  max-width: 30%;
                  max-height: 30%;
               }
            }
         }
      }
      .foot{
         position: fixed;
         padding: 10px 15px;
         background: $white;
         left: 0;
         right: 0;
         bottom: 0;

         .txt{
            font-size: 12px;
         }

         .link{
            font-size: 12px;
            margin: 0 10px 0 0;
         }
      }
      .page{
         background: $white;
         margin: 50px 0 0 0;
      }
      .top-content {
         background: $white;
         padding: 10px 15px;

         .content-box{

         }
         .logo {
            width: 70px;
            height: auto;
            margin: 0 0 0 0;
         }
         .card-img {
            max-width: 100px;
            max-height: 100px;
            width: auto;
            height: auto;
         }
         .h5 {
            margin: 5px 0 0 0;
            font-weight: $weight-bold;
         }
         .help {
            margin: 10px 0 0 0;
            font-weight: $weight-bold;
            color: grey;
            font-size: 12px;
         }
      }

   }

@media(max-width: $breakpoint-md){
   .voucher{
      .top-content {
         .logo{
            width: 60px !important;
         }
      }
      .fx-wizard{
         .wizard-head{
            display: block !important;

            .head-content{
               border-bottom: solid 1px $border-grey;
            }
         }
      }
      .voucher-card .image-back .image-box{
         display: none !important;
      }
   }
}

@media(max-width: $breakpoint-sm){
   .voucher{
      .top-content {
         position: relative;
   
         .logo{
            width: 60px !important;
            position: absolute;
            top: 18px;
         }
         .card-img {
            max-width: 90px !important;
            max-height: 90px !important;
         }
         .h5{
            font-size: 16px;
         }
         .help {
            margin: 20px 15px 0 0 !important;
         }
         .help-small{
            display: block !important;
            text-align: right;
         }
         .help-large{
            display: none;
         }
      }
   }
}
</style>